import { render, staticRenderFns } from "./PedidosTiendaDetailView.vue?vue&type=template&id=94da4ffa&scoped=true&lang=pug"
import script from "./PedidosTiendaDetailView.vue?vue&type=script&lang=js"
export * from "./PedidosTiendaDetailView.vue?vue&type=script&lang=js"
import style0 from "./PedidosTiendaDetailView.vue?vue&type=style&index=0&id=94da4ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94da4ffa",
  null
  
)

export default component.exports